module.exports = __webpack_public_path__ + "img/76.991b96f.png";